<template>
    <div>
        <b-modal @hidden="close" size="xl" :id="this.id" ref="finder" hide-footer :title="prefix + title">
            <TipoFiscalList @close="tipoFiscalSelect" :prefix="prefix" />
        </b-modal>
        <lg-form-input-finder v-model="localValue" fieldDescription="descricao" :label="label"
            invalidFeedback="Tipo Fiscal deve ser informado!" description="" @handleClean="handleClear">
            <template #prepend>
                <b-button @click="show" class="btn-input-finder" pressed>
                    <b-icon icon="search" />
                </b-button>
            </template>
        </lg-form-input-finder>
    </div>
</template>

<script>
import TipoFiscalList from "@/modules/cadastros/tipofiscal/TipoFiscalList.vue";
import LgFormInputFinder from "@/core/components/Form/LgFormInputFinder.vue";

export default {
    name: "LgFinderPageTipoFiscal",
    components: { LgFormInputFinder, TipoFiscalList },
    props: {
        id: String,
        value: Object,
        prefix: {
            type: String,
            default: "",
        },
        label: {
            type: String,
            default: "Tipo Fiscal",
        },
    },
    data() {
        return {
            localValue: this.value,
            title: "Tipo Fiscal",
        };
    },
    watch: {
        value(newValue) {
            this.localValue = newValue;
        },
        localValue(newValue) {
            this.$emit("input", newValue);
        },
    },
    methods: {
        async show() {
            await this.$refs.finder.show();
        },

        handleClear() {
            this.inputValue = {};
            this.$refs.finderModal.hide();
            this.$emit("input");

        },
        close() {
            this.$refs.finderModal.hide();
        },
        async tipoFiscalSelect(item) {
            this.localValue = item;
            this.$emit("onselect", item);
            await this.$bvModal.hide(this.id);
        },
    },
};
</script>
